<ng-container *ngIf="languageTranslateOptions$ | async; let languageTranslateOptions">
  <div class="translation-options-wrapper padding-half">
    <div class="flex items-center gap-half font-new-default">
      <div>
        <loop-icon name="language" width="18px"> </loop-icon>
      </div>
      <div class="flex flex-col gap-half">
        <ng-container *ngIf="isOriginal; else languageOptionsTpl">
          <ng-container *ngIf="toLanguage$ | async; let toLanguage">
            <loop-link (click)="translationsOptionsChange.next({ to: toLanguage })"
              >Translate to {{ languageTranslateOptions.to }}</loop-link
            >
          </ng-container>
        </ng-container>

        <ng-template #languageOptionsTpl>
          <div class="flex gap-quarter items-center">
            {{ languageTranslateOptions.from }}
            <loop-icon name="arrow-right" width="12px"></loop-icon>
            {{ languageTranslateOptions.to }}
          </div>
        </ng-template>
        <loop-link *ngIf="!isOriginal" (click)="translationsOptionsChange.next({ isOriginal: true })">
          Show original
        </loop-link>
      </div>
      <div>
        <loop-icon class="clickable-icon" name="gear" width="18px" (click)="openLanguageSelectorForm()"></loop-icon>
      </div>
    </div>
  </div>
</ng-container>
